import React from 'react'

export function VersionTag(props: { dark?: boolean }) {
  return (
    <div
      style={{
        bottom: 0,
        right: 0,
        color: '#000',
        borderRadius: '6px',
        padding: '6px',
        fontWeight: 'bold',
        fontSize: '12px',
        opacity: props.dark ? 0.6 : 0.1,
        textAlign: 'right',
      }}
    >
      {process.env.REACT_APP_ENV_DISPLAY_NAME} {process.env.REACT_APP_VERSION} ({process.env.REACT_APP_BUILD_NUMBER})
    </div>
  )
}